// extracted by mini-css-extract-plugin
export default {"layout":"About_layout__nAyOl"};